import { render } from "./MaintenanceReservationV3.vue?vue&type=template&id=48c7b024"
import script from "./MaintenanceReservationV3.vue?vue&type=script&lang=js"
export * from "./MaintenanceReservationV3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__